import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { CustomerApplications } from '@/types/customer-context'

export const customerApplicationsQueryKey = ['customer-applications']

export async function listCustomerApplications() {
  const response = await httpClient('financial').get<CustomerApplications>(
    '/v1/customer/applications',
  )

  return response.data
}

export function useCustomerApplications() {
  return useQuery({
    queryKey: customerApplicationsQueryKey,
    queryFn: listCustomerApplications,
  })
}
